import { Injectable } from '@angular/core';
import * as Rx from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { Collections } from '../collections.model';
import { RequestDataPayload } from './actions';
import { BackendErrorCode } from './backend';

export interface RequestStatusWrapper {
  readonly request: RequestDataPayload<any>;
  readonly statusObject: RequestStatus;
}

export interface RequestError {
  readonly errorCode: BackendErrorCode;
  readonly requestId?: string;
}

export interface RequestStatus {
  readonly ready: boolean;
  readonly error?: RequestError;
}

@Injectable()
export class RequestStatusHandler {
  private _statusStreamSubject$: Rx.Subject<RequestStatusWrapper>;

  constructor() {
    this._statusStreamSubject$ = new Rx.Subject();
  }

  get statusStream$() {
    return this._statusStreamSubject$.asObservable();
  }

  get$<K extends keyof Collections>(
    request: RequestDataPayload<K>,
  ): Rx.Observable<RequestStatus> {
    return this._statusStreamSubject$.pipe(
      filter(e =>
        e.request.clientRequestIds.some(id =>
          request.clientRequestIds.includes(id),
        ),
      ),
      map(e => e.statusObject),
    );
  }

  update<K extends keyof Collections>(
    request: RequestDataPayload<K>,
    status: RequestStatus,
  ) {
    this._statusStreamSubject$.next({
      request,
      statusObject: status,
    });
  }
}
